import { render, staticRenderFns } from "./public-booking.vue?vue&type=template&id=4f610a8c&scoped=true&"
import script from "./public-booking.ts?vue&type=script&lang=ts&"
export * from "./public-booking.ts?vue&type=script&lang=ts&"
import style0 from "./public-booking.scss?vue&type=style&index=0&id=4f610a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f610a8c",
  null
  
)

export default component.exports